module.exports = __webpack_public_path__ + "img/DishTV.b2fd9c4e.png";